<script setup>
import { onMounted } from "vue";

onMounted(() => {
  require("@/assets/js/compound-interest.js");
});
</script>
<template>
  <main class="seo-calculators compound-calculator">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Compound Interest Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading fw-300">Compound Interest Calculator</h1>
      <h2 class="page-sub-heading">Calculate your compound interest.</h2>

      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Principal Amount</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="totalInvestment"
                        value="10000"
                        min="10000"
                        max="10000000"
                        step="500"
                        id="total-investment-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="10000"
                    value="10000"
                    max="10000000"
                    id="total-investment-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">₹10,000</div>
                    <div class="slider__max">₹1,00,00,000</div>
                  </div>
                </div>

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Number of years</h3>
                    <div class="slider__input">
                      <input
                        class="number-of-years"
                        type="number"
                        name="timePeriod"
                        value="5"
                        step="1"
                        min="1"
                        max="25"
                        id="period-input"
                      /><span class="m-l-4">yrs</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="1"
                    max="25"
                    id="period-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">1 yrs</div>
                    <div class="slider__max">25 yrs</div>
                  </div>
                </div>

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Interest rate</h3>
                    <div class="slider__input">
                      <input
                        class="number-of-years"
                        type="number"
                        name="returnRate"
                        value="15"
                        step="0.1"
                        min="1"
                        max="50"
                        id="return-rate-input"
                      /><span>%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="1"
                    value="12"
                    step="0.1"
                    max="50"
                    id="return-rate-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">1 %</div>
                    <div class="slider__max">50 %</div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding">
            <aside class="calculator-output">
              <h3 class="calculator-output__heading">Principal Amount</h3>
              <div
                id="total-investment"
                class="calculator-output__amount--large"
              >
                ₹ 10,000
              </div>

              <div class="calculator-output__row">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Total Interest</h3>
                  <div
                    id="invested-amount"
                    class="calculator-output__amount--small"
                  >
                    ₹ 10,114
                  </div>
                </div>
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Total Amount</h3>
                  <div id="est-amount" class="calculator-output__amount--small">
                    ₹ 20,114
                  </div>
                </div>
              </div>
              <div class="calculator-output__chart-container">
                <canvas
                  id="mfChart"
                  width="200"
                  height="200"
                  style="
                    display: block;
                    box-sizing: border-box;
                    height: 200px;
                    width: 200px;
                  "
                ></canvas>
                <div class="calculator-output__chart-container--legend">
                  <div class="legend-title">
                    <span class="purple"></span>
                    <h3>Total Investment Amount</h3>
                  </div>
                  <div class="legend-title">
                    <span class="gold"></span>
                    <h3>Total Interest</h3>
                  </div>
                </div>
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is Compound Interest?</h2>
      <p></p>
      <p>
        Compound Interest is the interest you will receive on a loan or deposit,
        taking into account the initial amount and the previous interest
        accumulated over time. It can be seen as the interest you earn on
        interest, and thus, contributes to a faster increase rate on the
        principal amount.
      </p>
      <p>
        For example, if you add Rs. 10,000 in your account on a 1 percent annual
        interest, you will earn Rs. 100 in interest after a year, taking the
        total to Rs. 10,100. In the successive year, due to compound interest,
        you will earn 1 percent on Rs. 10,100 and not the principal amount of
        Rs. 10,000, making the total Rs. 10,201, which means CI is Rs. 101.
      </p>
      <p></p>
      <h2>What is a Compound Interest calculator?</h2>
      <p></p>
      <p>
        A Compound Interest calculator is used to calculate the projection for
        compound growth for your savings account or investment for different
        periods of time, based upon a certain rate of interest.
      </p>
      <p></p>
      <h2>How does a Compound Interest calculator work?</h2>
      <p></p>
      <p>
        The Compound Interest calculator uses three metrics, the principal
        amount, interest rate and the time period of money invested, and the
        Compound Interest formula, to calculate the Compound Interest.
      </p>
      <p></p>
      <h2>What is the formula of Compound Interest?</h2>
      <p></p>
      <p>The following formula is used to calculate Compound Interest:</p>
      <p>A = P (1 + r/n) ^ nt</p>
      <p>Where, CI = A – P</p>
      <p>
        Where:<br />
        CI = Compound Interest<br />
        A = Total amount received after a certain numbers of years<br />
        P = Principal Amount/Present Amount<br />
        r = Rate of Interest (percentage) / 100<br />
        N/n = Number of times interest compounds in a year (daily, monthly,
        yearly, etc)<br />
        T/t = Number of years
      </p>
      <p></p>
      <h2>How do we calculate Compound Interest?</h2>
      <p></p>
      <p>
        To calculate Compound Interest, you must know the three parameters
        required to compute it. These include the Principle Amount you’ve
        borrowed or mean to borrow, Let’s say Rs. 10,000. The number of years
        you will pay back the loan in, let’s say 10 years. The rate of interest
        is the extra interest you will have to pay on the loan, let’s say 10%.
        Also check how many times in the year is the interest compounded. For
        this example, let’s say annually, i.e., 1 time a year.
      </p>
      <p>
        Now use the CI calculator or use the Compound Interest formula to
        compute the total compound Interest you are liable to pay.
      </p>
      <p>
        A = P (1 + r/n) ^ nt<br />
        A = 10,000 (1 + 0.1) ^ (1)(10)
      </p>
      <p>
        Total Amount is Rs. 25,937.42<br />
        Where, P is Rs. 10,000, making CI Rs. 15,937.42
      </p>
      <p>
        You can calculate the Compound Interest by simply using the Upstox
        Compound Interest calculator.
      </p>
      <p></p>
      <h2>What are some examples of Compound Interest?</h2>
      <p></p>
      <p>
        Compound Interest can be calculated using the Compound Interest formula:
      </p>
      <p>A = P (1 + r/n) ^ nt – P</p>
      <p>CI = A – P</p>
      <p>
        Where:<br />
        CI = Compound Interest<br />
        A = Total Amount accrued<br />
        P = Principal Amount/Present Amount<br />
        R/r = Rate of Interest<br />
        N/n = Number of times interest compounds in a year<br />
        T/t = Number of years
      </p>
      <p>
        For example, you invested Rs. 5,000 in a fixed deposit that compounds
        interest quarterly with a 10% per annum rate of return. The amount
        invested remains in the fixed deposit for 5 years. Therefore, the values
        of the variables will be:
      </p>
      <p>
        P = 5,000<br />
        r = 10/100 = 0.1<br />
        N/n = 4<br />
        T/t = 5
      </p>
      <p>Now, putting the values in the formula:</p>
      <p>
        A = 5000 (1 + 0.1/4) ^ 4×5<br />
        A = 8193.08
      </p>
      <p>
        CI = A – P<br />
        CI = 8193.08 – 5000
      </p>
      <p>So, in 5 years, your Compound Interest is Rs. 3193.08.</p>
      <p>
        Here is another example for calculating Compound Interest. Imagine you
        have put Rs. 10,000 in your savings account for 10 years, earning 5%
        interest per year. Our compounding in this case is yearly. Therefore,
        the values of the variables will be:
      </p>
      <p>
        P = 10,000<br />
        R/r = 0.05<br />
        N/n = 1<br />
        T/t = 10
      </p>
      <p>Now, putting the values in the formula:</p>
      <p>
        A = 10000 (1 + 0.05/1) ^ 1×10<br />
        A = 16,288.946
      </p>
      <p>
        CI = A – P<br />
        CI = 16288.946 – 10000
      </p>
      <p>
        So, in 10 years, you will receive a total Compound Interest of Rs.
        6,288.946.
      </p>
      <p></p>
      <h2>
        What are the benefits of using a Compound Interest calculator online?
      </h2>
      <p></p>
      <p>
        Calculating the Compound Rate can be extremely difficult and tedious.
        Manual calculation is also prone to mistakes. On the other hand, using a
        Compound Interest calculator is easy, reliable, accurate and fast.
      </p>
      <p></p>
      <h2>How is Upstox the best online Compound Interest calculator?</h2>
      <p></p>
      <p>
        Being a top player of the finance world, Upstox is committed to
        providing a seamless experience when it comes to your finances. Our
        online Compound Interest calculator is built with the best user
        interface, making it easy to use, speedy &amp; comfortable. The online
        CI calculator is designed to help you align your financial goals &amp;
        current investments.
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse1">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How to use the Compound Interest calculator?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The Compound Interest calculator uses three metrics, the
                  principal amount, interest rate and the time period of money
                  invested, and a mathematical formula, to calculate the
                  Compound Interest.
                </p>
                <p>
                  To use the Compound Interest calculator, you must know these
                  aforementioned three metrics and fill in the correct
                  information in their respective places. The calculator will
                  automatically put in the formula and calculate the Compound
                  Interest for you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse2">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >How do you calculate Compound Interest without
                    formula?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Calculating Compound Interest without the formula is a tedious
                  process, as it would have to be calculated as many times as it
                  is compounded for every year &amp; then totaled.
                </p>
                <p>
                  For example, let’s say Ankit has Rs. 10,000 in his saving
                  account &amp; he earns 5% interest on it compounded annually,
                  he would simply have to calculate the interest earned every
                  year.
                </p>
                <p>
                  Year 1: 5% of 10,000 = Rs. 500<br />
                  Year 2: 5% of 10,500 = Rs. 525<br />
                  Year 3: 5% of 11,025 = Rs. 551.25
                </p>
                <p>And so on. So CI earned in 3 years is Rs. 1,576.25</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse3">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What are the three steps of calculating Compound
                    Interest?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Using the Compound Interest calculator, you can find the
                  Compound Interest in three steps:
                </p>
                <p>
                  Identify the three metrics used for calculation; the principal
                  amount, interest rate and the time period of money
                  invested.<br />
                  Insert the values of the metrics in their respective places in
                  the calculator.<br />
                  Press submit/calculate and the calculator will give you the
                  answer within seconds!
                </p>
                <p>
                  Using the Compound Interest calculation formula, you can
                  calculate the Compound Interest with the following steps:
                </p>
                <p>
                  A = P (1 + r/n) ^ nt<br />
                  CI = A – P
                </p>
                <p>
                  Solve the equation within the brackets.<br />
                  The number within the bracket is then solved with the
                  exponential number (nt).<br />
                  This number is multiplied with the principal amount to receive
                  the total amount accrued. The CI is the difference between
                  total amount &amp; principal amount.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse4">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How do you calculate Compound Interest monthly?</span>
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Compound Interest can be calculated monthly using the same
                  Compound Interest formula:
                </p>
                <p>
                  A = P (1 + r/n) ^ nt – P<br />
                  CI = A – P
                </p>
                <p>
                  Where:<br />
                  CI = Compound Interest<br />
                  A = Total amount accrued<br />
                  P = Principal Amount/Present Amount<br />
                  R/r = Rate of Interest<br />
                  N/n = Number of times interest compounds in a year<br />
                  T/t = Number of years
                </p>
                <p>
                  However, while calculating monthly, the variable N/n will be
                  12 for the number of months, hereby making it number of times
                  interest compounds in a year.
                </p>
                <p>
                  For example, you invested Rs. 5,000 in a fixed deposit that
                  compounds interest monthly with a 10% rate of return. The
                  amount invested remains in the fixed deposit for 1 year.
                  Therefore, the values of the variables will be:
                </p>
                <p>
                  P = 5,000<br />
                  R/r = 0.1<br />
                  N/n = 12<br />
                  T/t = 1
                </p>
                <p>Now, putting the values in the formula:</p>
                <p>
                  A = 5000 (1 + 0.1/12) ^ 12×1<br />
                  A = 5523.565
                </p>
                <p>
                  CI = 5523.565 – 5000<br />
                  CI = 523.565
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse5">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How can a CI calculator help you?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Calculating the Compound Rate can be extremely difficult and
                  tedious, and is prone to error. On the other hand, using a
                  Compound Interest calculator is easy, reliable, accurate and
                  fast.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse6">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are some examples of Compound Interest?</span>
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Compound Interest can be calculated using the Compound
                  Interest formula:
                </p>
                <p>CI = P (1 + r/n) ^ nt – P</p>
                <p>
                  Where:<br />
                  CI = Compound Interest<br />
                  P = Principal Amount/Present Amount<br />
                  R/r = Rate of Interest<br />
                  N/n = Number of times interest compounds in a year<br />
                  T/t = Number of years
                </p>
                <p>
                  For example, you invested Rs. 5,000 in a fixed deposit that
                  compounds interest quarterly with a 10% per annum rate of
                  return. The amount invested remains in the fixed deposit for 5
                  years. Therefore, the values of the variables will be:
                </p>
                <p>
                  P = 5,000<br />
                  R/r = 0.1<br />
                  N/n = 4<br />
                  T/t = 5
                </p>
                <p>Now, putting the values in the formula:</p>
                <p>
                  CI = 5000 (1 + 0.1/4) ^ 4×5 – 5000<br />
                  CI = 3,193.08
                </p>
                <p>So, in 5 years, you will have a total of Rs. 8,193.08.</p>
                <p>
                  Here is another example for calculating Compound Interest.
                  Imagine you have put Rs. 10,000 in your savings account for 10
                  years, earning 5% interest per year. Our compounding in this
                  case is yearly. Therefore, the values of the variables will
                  be:
                </p>
                <p>
                  P = 10,000<br />
                  R/r = 0.05<br />
                  N/n = 1<br />
                  T/t = 10
                </p>
                <p>Now, putting the values in the formula:</p>
                <p>
                  CI = 10000 (1 + 0.05/1) ^ 1×10 – 10000<br />
                  CI = 6,288.946
                </p>
                <p>So, in 10 years, you will have a total of Rs. 16,288.946.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse7">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >How is Upstox the best online Compound Interest
                    calculator?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse7" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Being a top player of the finance world, Upstox is committed
                  to providing a seamless experience when it comes to your
                  finances. Our online Compound Interest calculator is built
                  with the best user interface, making it easy to use, speedy
                  &amp; comfortable. The online CI calculator is designed to
                  help you align your financial goals &amp; current investments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse8">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What is the formula of Compound Interest annually?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Compound Interest can be calculated annually using the same
                  Compound Interest formula:
                </p>
                <p>
                  A = P (1 + r/n) ^ nt – P<br />
                  CI = A – P
                </p>
                <p>
                  Where:<br />
                  CI = Compound Interest<br />
                  A = Total amount accrued<br />
                  P = Principal Amount/Present Amount<br />
                  R/r = Rate of Interest<br />
                  N/n = Number of times interest compounds in a year<br />
                  T/t = Number of years
                </p>
                <p>
                  However, while calculating annually, the variable N/n will be
                  1, hereby making it number of times interest compounds in a
                  year.
                </p>
                <p>
                  For example, you invested Rs. 5,000 in a fixed deposit that
                  compounds interest monthly with a 10% rate of return. The
                  amount invested remains in the fixed deposit for 1 year.
                  Therefore, the values of the variables will be:
                </p>
                <p>
                  P = 5,000<br />
                  R/r = 0.1<br />
                  N/n = 1<br />
                  T/t = 1
                </p>
                <p>Now, putting the values in the formula:</p>
                <p>
                  A = 5000 (1 + 0.1/1) ^ 1×1<br />
                  A = 5500
                </p>
                <p>
                  CI = 5500 – 5000<br />
                  CI = 500
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
